export default __webpack_public_path__ + "static/media/casco.6075c2cc.svg";